'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/pdpRework/vto-modal'));
    processInclude(require('./product/pdpRework/shadeFinder'));
});
